import Chart from "react-apexcharts";
import React from "react";
import styled from "styled-components";
import { VscCircleFilled } from "react-icons/vsc";
import { kFormatter2, kFormatter3 } from "utils/format";
const TodayTransactionsChart = ({ options, countAmount, data }) => {
  //const colors = ["#01A926", "#FE0004", "#F9C74F"];

  return (
    <NewStyle>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "80%",
          margin: "10px auto",
        }}
      >
        <div>
          <VscCircleFilled style={{ color: "#01A926" }} size={15} />
          Successful
        </div>
        <div>
          <VscCircleFilled style={{ color: "#FE0004" }} size={15} />
          Failed
        </div>
        <div>
          <VscCircleFilled style={{ color: "#F9C74F" }} size={15} />
          Pending
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <Chart
          series={options.series}
          options={options.options}
          type="donut"
          height={"240"}
        />
        <div
          style={{
            color: "black",
            position: "absolute",
            top: "50%",
            transform: "translateY(-70%)",
            width: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: "12px" }}>COUNT</div>
          <p style={{ color: "black", fontSize: "18px", marginTop: "-1px" }}>
            {countAmount}
          </p>
        </div>
      </div>
      <div
        style={{
          width: "80%",
          margin: "10px auto",
          fontSize: "14px",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <VscCircleFilled style={{ color: "#01A926" }} size={15} />
          <div>
            <div>Amount: {kFormatter3(data[1]?.successfulAmount)}</div>
            <div>Count: {kFormatter2(data[1]?.successfulCount)}</div>
          </div>
        </div>
        <br></br>
        <div
          style={{
            display: "flex",
          }}
        >
          <VscCircleFilled style={{ color: "#FE0004" }} size={15} />
          <div>
            <div>Amount: {kFormatter3(data[2]?.failedAmount)}</div>
            <div>Count: {kFormatter2(data[2]?.failedCount)}</div>
          </div>
        </div>
        <br></br>

        <div
          style={{
            display: "flex",
          }}
        >
          <VscCircleFilled style={{ color: "#F9C74F" }} size={15} />
          <div>
            <div
              style={{
                display: "flex",
              }}
            >
              Amount: {kFormatter3(data[0]?.pendingAmount)}
            </div>
            <div>Count: {kFormatter2(data[0]?.pendingCount)}</div>
          </div>
        </div>
      </div>
    </NewStyle>
  );
};

export default TodayTransactionsChart;

const NewStyle = styled.div`
  .apexcharts-legend {
    flex-direction: column;
    justify-content: center !important;
    bottom: 0 !important;
    width: 30%;
    margin: 0 auto;
  }
`;
